import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPendingCollection = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetPendingCollectionResponseData> => {
        const { data } = await send<Types.IGetPendingCollectionRequestData, Types.IGetPendingCollectionResponseData>({
            ID: 33026,
            description: 'Get Transaction history',
            responses: [33027, 33028],
            type: 'Withdraw',
            status: 'Pending',
            corrections: true
        });

        return data;
    }, [send]);
};
